module.exports = __webpack_public_path__ + "img/aoi.c7f4e4a3.svg";